/**
 * Идентификатор ФОИВ (ФЕДЕРАЛЬНЫЕ ОРГАНЫ ИСПОЛНИТЕЛЬНОЙ ВЛАСТИ).
 *
 * @see https://ofd.ru/razrabotchikam/ferma#%D0%B2%D0%BE%D0%B7%D0%BC%D0%BE%D0%B6%D0%BD%D1%8B%D0%B5_%D0%B7%D0%BD%D0%B0%D1%87%D0%B5%D0%BD%D0%B8%D1%8F_%D0%BF%D0%B0%D1%80%D0%B0%D0%BC%D0%B5%D1%82%D1%80%D0%B0_foivid
 */
export enum FoivId {
	/** Министерство внутренних дел Российской Федерации */
	Mvd = "001",

	/** Министерство Российской Федерации по делам гражданской обороны, чрезвычайным ситуациям и ликвидации последствий стихийных бедствий */
	Emercom = "002",

	/** Министерство иностранных дел Российской Федерации */
	Mid = "003",

	/** Федеральное агентство по делам Содружества Независимых Государств, соотечественников, проживающих за рубежом, и по международному гуманитарному сотрудничеству */
	Rossotrudnichestvo = "004",

	/** Министерство обороны Российской Федерации */
	MoD = "005",

	/** Федеральная служба по военно-техническому сотрудничеству */
	Fsvts = "006",

	/** Федеральная служба по техническому и экспортному контролю */
	Fstek = "007",

	/** Министерство юстиции Российской Федерации */
	Minjust = "008",

	/** Федеральная служба исполнения наказаний */
	Fsinn = "009",

	/** Федеральная служба судебных приставов */
	Fssp = "010",

	/** Государственная фельдъегерская служба Российской Федерации (федеральная служба) */
	Gfs = "011",

	/** Служба внешней разведки Российской Федерации (федеральная служба) */
	Svr = "012",

	/** Федеральная служба безопасности Российской Федерации (федеральная служба) */
	Fsb = "013",

	/** Федеральная служба войск национальной гвардии Российской Федерации (федеральная служба) */
	Rosgvardiya = "014",

	/** Федеральная служба охраны Российской Федерации (федеральная служба) */
	Fso = "015",

	/** Федеральная служба по финансовому мониторингу (федеральная служба) */
	Rosfinmonitoring = "016",

	/** Федеральное архивное агентство (федеральное агентство) */
	Rosarkhiv = "017",

	/** Главное управление специальных программ Президента Российской Федерации (федеральное агентство) */
	Gusp = "018",

	/** Управление делами Президента Российской Федерации (федеральное агентство) */
	Udp = "019",

	/** Министерство здравоохранения Российской Федерации */
	Minzdrav = "020",

	/** Федеральная служба по надзору в сфере здравоохранения */
	Roszdravnadzor = "021",

	/** Министерство культуры Российской Федерации */
	Mincult = "022",

	/** Министерство науки и высшего образования Российской Федерации */
	Minobrnauki = "023",

	/** Министерство природных ресурсов и экологии Российской Федерации */
	Minprirody = "024",

	/** Федеральная служба по гидрометеорологии и мониторингу окружающей среды */
	Roshydromet = "025",

	/** Федеральная служба по надзору в сфере природопользования */
	Rosprirodnadzor = "026",

	/** Федеральное агентство водных ресурсов */
	Rosvodresursy = "027",

	/** Федеральное агентство лесного хозяйства */
	Rosleskhoz = "028",

	/** Федеральное агентство по недропользованию */
	Rosnedra = "029",

	/** Министерство промышленности и торговли Российской Федерации */
	Minpromtorg = "030",

	/** Федеральное агентство по техническому регулированию и метрологии */
	Rosstandart = "031",

	/** Министерство просвещения Российской Федерации */
	Minpros = "032",

	/** Министерство Российской Федерации по развитию Дальнего Востока и Арктики */
	Minvostokrazvitiya = "033",

	/** Министерство сельского хозяйства Российской Федерации */
	Minselhoz = "034",

	/** Федеральная служба по ветеринарному и фитосанитарному надзору */
	Rosselkhoznadzor = "035",

	/** Федеральное агентство по рыболовству */
	Rosrybolovstvo = "036",

	/** Министерство спорта Российской Федерации */
	Minsport = "037",

	/** Министерство строительства и жилищно-коммунального хозяйства Российской Федерации */
	Minstroy = "038",

	/** Министерство транспорта Российской Федерации */
	Mintrans = "039",

	/** Федеральная служба по надзору в сфере транспорта */
	Rostransnadzor = "040",

	/** Федеральное агентство воздушного транспорта */
	Rosaviatsiya = "041",

	/** Федеральное дорожное агентство */
	Rosavtodor = "042",

	/** Федеральное агентство железнодорожного транспорта */
	Roszheldor = "043",

	/** Федеральное агентство морского и речного транспорта */
	Rosmorrechflot = "044",

	/** Министерство труда и социальной защиты Российской Федерации */
	Mintrud = "045",

	/** Федеральная служба по труду и занятости */
	Rostrud = "046",

	/** Министерство финансов Российской Федераци */
	Minfin = "047",

	/** Федеральная налоговая служба */
	Fns = "048",

	/** Федеральная пробирная палата (федеральная служба) */
	Probe = "049",

	/** Федеральная служба по регулированию алкогольного рынка */
	Rosalkogol = "050",

	/** Федеральная таможенная служба */
	Fts = "051",

	/** Федеральное казначейство (федеральная служба) */
	Treasury = "052",

	/** Федеральное агентство по управлению государственным имуществом */
	Rosimushchestvo = "053",

	/** Министерство цифрового развития, связи и массовых коммуникаций Российской Федерации */
	Mintsyfra = "054",

	/** Федеральная служба по надзору в сфере связи, информационных технологий и массовых коммуникаций */
	Roskomnadzor = "055",

	/** Федеральное агентство по печати и массовым коммуникациям */
	Rospechat = "056",

	/** Федеральное агентство связи */
	Rossvyaz = "057",

	/** Министерство экономического развития Российской Федерации */
	Minekonomrazvitiya = "058",

	/** Федеральная служба по аккредитации */
	Rosakkreditatsiya = "059",

	/** Федеральная служба государственной статистики */
	Rosstat = "060",

	/** Федеральная служба по интеллектуальной собственности */
	Rospatent = "061",

	/** Федеральное агентство по туризму */
	Rostourism = "062",

	/** Министерство энергетики Российской Федерации */
	Minenergo = "063",

	/** Федеральная антимонопольная служба */
	Fas = "064",

	/** Федеральная служба государственной регистрации, кадастра и картографии */
	Rosreestr = "065",

	/** Федеральная служба по надзору в сфере защиты прав потребителей и благополучия человека */
	Rospotrebnadzor = "066",

	/** Федеральная служба по надзору в сфере образования и науки */
	Rosobrnadzor = "067",

	/** Федеральная служба по экологическому, технологическому и атомному надзору */
	Rostekhnadzor = "068",

	/** Федеральное агентство по государственным резервам */
	Rosrezerv = "069",

	/** Федеральное медико-биологическое агентство */
	Fmba = "070",

	/** Федеральное агентство по делам молодежи */
	Rosmolodezh = "071",

	/** Федеральное агентство по делам национальностей */
	Fadn = "072",
}
